/**
 * Error Messages Constants
 * Centralized error messages for consistent user-facing error handling
 */

export const ERROR_MESSAGES = {
  // HTTP Status Code Errors
  BAD_REQUEST: 'Invalid request. Please check your message and try again.',
  UNAUTHORIZED: 'Authentication failed. Please log in and try again.',
  FORBIDDEN: 'Access denied. You do not have permission to use this service.',
  TOO_MANY_REQUESTS: 'Too many requests. Please wait a moment and try again.',
  INTERNAL_SERVER_ERROR: 'Server error. Please try again later.',
  BAD_GATEWAY:
    'The server is temporarily unavailable. Please try again in a moment.',
  SERVICE_UNAVAILABLE:
    'Service temporarily unavailable. Please try again later.',
  GATEWAY_TIMEOUT:
    'The request took too long to process. This might be due to high server load. Please try again.',

  // Network Errors
  TIMEOUT:
    'Request timeout. The server is taking longer than expected to respond. Please try again.',
  NETWORK_ERROR: 'Network error. Please check your internet connection.',

  // Chat Service Errors
  CHAT_SERVICE_ERROR: 'Chat service error',
  FAILED_TO_SEND: 'Failed to send message. Please try again.',
  CHAT_NOT_INITIALIZED: 'Chat not initialized. Please refresh the page.',
  INVALID_MESSAGE: 'Please enter a message or record audio.',

  // API Response Errors
  INVALID_RESPONSE: 'Invalid response: No data received',
  MISSING_REQUIRED_FIELDS: 'Invalid response: Missing required fields',
  UNEXPECTED_ERROR: 'An unexpected error occurred. Please try again.',
  UNEXPECTED_RESPONSE_FORMAT: 'Unexpected response format from staging API',

  // API Route Errors
  METHOD_NOT_ALLOWED: 'Method not allowed',
  REQUEST_BODY_REQUIRED: 'Request body is required',
  REQUEST_TIMED_OUT:
    'Request timed out. The staging server took too long to respond.',
  CORS_ERROR: 'CORS error when connecting to staging API',
  ERROR_FROM_STAGING_API: 'Error from staging API',
  INTERNAL_SERVER_ERROR_GENERIC: 'Internal server error',
} as const;
